import { useState } from "react";
import { SectionHeader } from "./shared";
import faqVisual from "../../assets/home/faq-visual.jpg";
import plusIcon from "../../assets/home/faq-plus.svg";

const FAQS = [
  { q: "What are the available loan amounts?", a: "Eligible applicants can apply for a loan amount of ₹5,000–₹50,000, subject to applicable eligibility and assessment criteria." },
  { q: "What is the repayment tenure?", a: "The repayment tenure is 61–90 days, subject to applicable eligibility and assessment criteria." },
  { q: "What is the interest rate?", a: "The interest rate is 3% per 30-day period, with an APR of up to 35% (fixed). Review the final loan terms before accepting." },
  { q: "What is the processing fee?", a: "The processing fee is up to 10% of the loan amount. GST is charged extra (GST exclusive)." },
  { q: "Who is eligible to apply?", a: "This product is intended for salaried individuals. Final eligibility is subject to applicable eligibility and assessment criteria." },
  { q: "What CIBIL score is required?", a: "Indicative CIBIL score 650+; final assessment is subject to applicable eligibility and assessment criteria." },
  { q: "How do I repay my loan?", a: "Repayment method, timing and applicable charges are pending confirmation and subject to final loan terms." },
  { q: "When will I receive a lending decision?", a: "The lender's decision is subject to applicable eligibility and assessment criteria. Review the final terms before accepting a loan." },
];

export default function HomeFaq() {
  const [collapsed, setCollapsed] = useState<Set<number>>(new Set());

  const toggle = (i: number) =>
    setCollapsed((prev) => {
      const next = new Set(prev);
      if (next.has(i)) next.delete(i);
      else next.add(i);
      return next;
    });

  return (
    <section className="bg-[#f8fafc] px-4 sm:px-6 lg:px-[80px] py-[60px]">
      <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row gap-10 lg:gap-12">
        <div className="relative hidden lg:flex w-[392px] shrink-0 rounded-[28px] overflow-hidden">
          <img src={faqVisual} alt="" loading="lazy" className="absolute inset-0 size-full object-cover" />
          <div className="absolute inset-0 bg-[rgba(15,23,42,0.08)]" />
          <div
            className="relative flex-1 flex flex-col justify-between p-6"
            style={{ backgroundImage: "linear-gradient(109.4deg, rgba(15, 23, 42, 0) 25%, rgba(15, 23, 42, 0.8) 75%)" }}
          >
            <span className="self-start bg-white/10 border border-white/15 px-3 py-2 rounded-full font-bold text-[12px] text-white tracking-[1px] uppercase">
              Loan guidance
            </span>
            <div className="flex flex-col gap-3">
              <p className="font-bold text-[28px] leading-[34px] text-white">Clear answers for every step of your loan journey.</p>
              <p className="text-[14px] leading-[22px] text-white/80">Review the most common questions before you apply.</p>
            </div>
          </div>
        </div>

        <div className="flex-1 min-w-0 flex flex-col gap-8">
          <SectionHeader
            align="left"
            badge="Help & Support"
            title="Frequently Asked Questions"
            subtitle="Get answers regarding product queries and loan assessments. Final terms are subject to applicable eligibility and assessment criteria."
          />
          <div className="flex flex-col gap-4">
            {FAQS.map((item, i) => {
              const open = !collapsed.has(i);
              return (
                <div key={item.q} className="flex flex-col gap-3 bg-white border border-[#e5e7eb] rounded-[20px] p-6">
                  <button
                    type="button"
                    onClick={() => toggle(i)}
                    aria-expanded={open}
                    className="flex items-center justify-between gap-4 text-left"
                  >
                    <span className="flex-1 font-extrabold text-[#1a1a4b] text-[16px]">{item.q}</span>
                    <img alt="" src={plusIcon} className="size-4 shrink-0" />
                  </button>
                  {open && <p className="text-[#6a7282] text-[14px] leading-[22px]">{item.a}</p>}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
